<template>
  <div>
    <template v-if="isMobile()">
      <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
      <v-card
        outlined
        v-else-if="produtosEmAberto.length > 0"
        v-for="(prod, i) in produtosEmAberto"
        :key="i"
        class="grey lighten-4 mt-2"
      >
        <v-card-title class="subtitle-1 font-weight-bold">{{
          prod.descproduto
        }}</v-card-title>
        <v-card-subtitle class="font-weight-bold pb-2"
          >{{ prod.emb }} - ({{ prod.gp }}-{{ prod.sgp }}-{{
            prod.item
          }})</v-card-subtitle
        >
        <v-card-text>
          <p class="mb-1">
            Qtde Pedido <span class="float-right">{{ prod.qtdepedido }}</span>
          </p>
          <p class="mb-1">
            Saldo Contrato
            <span class="float-right">{{ prod.saldofutura }}</span>
          </p>
          <p class="mb-1">
            Disp p/ retirada
            <span class="float-right">{{ prod.saldoremessas }}</span>
          </p>
          <p class="mb-1">
            Retirada Obrigatória
            <span class="float-right">{{
              prod.precisaretirar ? "Sim" : "Não"
            }}</span>
          </p>
        </v-card-text>
      </v-card>
      <v-alert v-else text type="info" class="subtitle-1"
        >Nenhum produto em aberto</v-alert
      >
    </template>
    <v-card v-else flat color="grey lighten-3" rounded="lg">
      <v-card-text>
        <v-data-table
          :items="produtosEmAberto"
          :headers="headers"
          no-data-text="Nenhum produto em aberto"
          :disable-sort="isMobile()"
          :loading="loading"
          loading-text="Carregando produtos..."
        >
          <template v-slot:[`item.precisaretirar`]="{ item }">
            {{ item.precisaretirar ? "Sim" : "Não" }}
          </template>
          <template v-slot:[`item.retiradas`]="{item}">
            <btn-retiradas-produto v-if="item.retiradas.length > 0" :produto="item" />
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import BtnRetiradasProduto from "./BtnRetiradasProduto.vue";
export default {
  components: { BtnRetiradasProduto },
  props: {
    cliente: Object,
  },
  computed: mapState("clientes", ["produtosEmAberto"]),
  data: () => ({
    loading: true,
    headers: [
      { text: "Filial", value: "filial" },
      { text: "Gp", value: "gp" },
      { text: "SGp", value: "sgp" },
      { text: "Item", value: "item" },
      { text: "Produto", value: "descproduto" },
      { text: "Embalagem", value: "emb" },
      { text: "Saldo em Pedido", value: "qtdepedido" },
      { text: "Saldo em Futura", value: "saldofutura" },
      { text: "Disp. p/ retirada", value: "saldoremessas" },
      { text: "Retirada Obrigatória", value: "precisaretirar" },
      { text: "Retiradas", value: "retiradas" },
    ],
  }),
  methods: {
    ...mapActions("clientes", ["getProdutosEmAberto"]),
    isMobile() {
      return this.$mq == "sm";
    },
  },
  async mounted() {
    this.loading = true;
    await this.getProdutosEmAberto({ pesquisa: this.cliente.matricula });
    this.loading = false;
  },
};
</script>

<style>
</style>